import { render as reactRender } from "react-dom";
import React, { createElement } from "react";
import App from "src/App";

// Render helper to handle hot reloading
const render = ({ store, ErrorBoundary, initialEntries }: React.ComponentProps<typeof App>) => {
    reactRender(
        createElement(App, {
            store,
            ErrorBoundary: ErrorBoundary.getPlugin("react"),
            initialEntries,
        }),
        document.getElementById("di-os-container")
    );

    if (process.env.NODE_ENV === "development" && module.hot) {
        module.hot.accept("../App", () => {
            const NextApp = require("../App").default;
            reactRender(
                createElement(NextApp, {
                    store,
                    ErrorBoundary: ErrorBoundary.getPlugin("react"),
                    initialEntries,
                }),
                document.getElementById("di-os-container")
            );
        });
    }
};

export default render;
